
import React from 'react';
import { MapPin, Globe } from 'lucide-react';

interface ServiceLocationLabelProps {
  deliveryMethod?: "virtual" | "in-person" | "both" | null;
  location?: string;
  className?: string;
}

export const ServiceLocationLabel: React.FC<ServiceLocationLabelProps> = ({ 
  deliveryMethod, 
  location,
  className = ""
}) => {
  if (!deliveryMethod) return null;

  if (deliveryMethod === "virtual") {
    return (
      <div className={`flex items-center text-xs text-gray-500 ${className}`}>
        <Globe size={12} className="mr-1" />
        Virtual Only
      </div>
    );
  }

  if (deliveryMethod === "in-person" && location) {
    return (
      <div className={`flex items-center text-xs text-gray-500 ${className}`}>
        <MapPin size={12} className="mr-1" />
        {location}
      </div>
    );
  }

  if (deliveryMethod === "both" && location) {
    return (
      <div className={`flex items-center text-xs text-gray-500 ${className}`}>
        <MapPin size={12} className="mr-1" />
        In-Person · {location}
      </div>
    );
  }

  return null;
};
